import { render } from "./KOLMemberCreate.vue?vue&type=template&id=adcff884"
import script from "./KOLMemberCreate.vue?vue&type=script&lang=js"
export * from "./KOLMemberCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__